import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "../Components/Navbar/Navbar";
import Sidebar from "../Components/Sidebar/Sidebar";
import Footer from "../Components/Footer/Footer";
import routes from "routes.js";
import AuthCheck from "Components/Common/AuthCheck/AuthCheck";
import { loadDecrypted } from "Common Usage/localStorageUtils";
import { permissionRouteMap } from "utils/permissionRouteMap";

const canAccess = (permissions, permissionKey) => {
  if (!permissionKey) return true;
  const chain = permissionKey.split(".");
  let current = permissions;

  for (let i = 0; i < chain.length; i++) {
    const key = chain[i];
    if (!current[key]) return false;

    current = current[key];

    if (current.subModule && chain[i + 1]) {
      current = current.subModule;
    }
  }

  if (current.isAllPermission) return true;
  return current.permissions?.view === true;
};

const Admin = (props) => {
  const { ...rest } = props;
  const location = useLocation();

  const [open, setOpen] = useState(true);
  const [currentRoute, setCurrentRoute] = useState("Main Dashboard");
  const [isLoading, setIsLoading] = useState(true);

  const getActiveRoute = (routes) => {
    let activeRoute = "Main Dashboard";

    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      } else {
        const pathArray = window.location.pathname.split("/").filter(Boolean);

        if (routes[i]?.findPath === pathArray[1]) {
          for (let j = 0; j < routes[i]?.children?.length; j++) {
            if (routes[i]?.children[j]?.nestedFindPath === pathArray[2]) {
              setCurrentRoute(routes[i]?.children[j]?.name);
            }
          }
        }
      }
    }

    return activeRoute;
  };

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        if (prop.children) {
          return (
            <Route path={prop.path} element={prop.component} key={key}>
              {prop.children.map((child, childKey) => (
                <Route
                  path={child.path}
                  key={`${key}-${childKey}`}
                  element={child.component}
                />
              ))}
            </Route>
          );
        } else if (prop.path) {
          return <Route path={prop.path} element={prop.component} key={key} />;
        }
      }
      return null;
    });
  };

  useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);

  useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  const userPermissions =
    JSON.parse(loadDecrypted("HeartConnect-Permissions")) || {};

  const rawPath = location.pathname.replace("/admin/", "").replace(/\/$/, "");
  const routeKey = rawPath === "" ? "dashboard" : rawPath;
  const permissionKey = permissionRouteMap[routeKey];
  const allowed = canAccess(userPermissions, permissionKey);

  if (!allowed && !isLoading) {
    console.log("⛔ ACCESS BLOCKED:", routeKey, "→", permissionKey);
    return <Navigate to="/admin/dashboard" replace />;
  }

  return (
    <>
      {isLoading ? (
        <AuthCheck setIsLoading={setIsLoading} layoutType="admin" />
      ) : (
        <div className="flex h-full w-full">
          <Sidebar open={open} onClose={() => setOpen(false)} />

          <div className="h-full w-full bg-[#fff1f6] dark:!bg-navy-900">
            <main className="mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]">
              <div className="h-full">
                <Navbar
                  onOpenSidenav={() => setOpen(true)}
                  brandText={currentRoute}
                  {...rest}
                />

                <div className="mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
                  <Routes>
                    {getRoutes(routes)}
                    <Route
                      path="/"
                      element={<Navigate to="/admin/dashboard" replace />}
                    />
                    <Route path="*" element={<Navigate to="/404" />} />
                  </Routes>
                </div>

                <Footer />
              </div>
            </main>
          </div>
        </div>
      )}
    </>
  );
};

export default Admin;
